import { Grid } from '@mui/material'
import ParentTeacherConference from '..'
import MyStudentProfile from '../../MyStudentProfile'
import React, { useEffect, useState } from 'react';
import {
    Box,
    Tabs,
    Tab,
    Paper,
    Button
} from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { postMeetingPreMeeting } from '../../../../Utils/apiService';
import { useNavigate } from 'react-router-dom';
import KenSnackbar from '../../../../GlobalComponents/KenSnackbar';

const modules = {
    toolbar: [
        ['italic', 'bold', 'underline', 'strike', 'link'],
        [{ color: [] }],
        [{ align: [] }],
        [{ list: 'bullet' }]
    ]
};

const formats = ['italic', 'bold', 'underline', 'strike', 'link', 'color', 'align', 'list'];

const ParentSpecific = () => {
    const [tabValue, setTabValue] = useState(0);
    const [preMeetingNote, setPreMeetingNote] = useState('');
    const [postMeetingNote, setPostMeetingNote] = useState('');
    const navigate = useNavigate();
    const url = window.location.pathname;
    const segments = url.split('/');
    const studentId = segments[segments.length - 1];
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error' | 'info' | 'warning'>('success');
    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    useEffect(() => {
        const storedPTCNotes = localStorage.getItem("PTCNotes");
        if (storedPTCNotes) {
            try {
                const parsed = JSON.parse(storedPTCNotes);
                setPreMeetingNote(parsed?.Pre_Meeting_Notes__c || '');
                setPostMeetingNote(parsed?.Post_Meeting_Notes__c || '');
            } catch (error) {
                console.error("Error parsing stored PTCNotes:", error);
            }
        }
    }, []);

    const showSnackbar = (message: string, severity: 'success' | 'error' | 'info' | 'warning') => {
        console.log("Showing snackbar:", message, severity); // Debug log
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    };

    const handlePostPreMeeting = async () => {
        const payload = {
            Post_Meeting_Notes__c: postMeetingNote,
            Pre_Meeting_Notes__c: preMeetingNote
        };

        try {
            const response = await postMeetingPreMeeting(payload, studentId);
            showSnackbar(`Notes saved`, "success");
            localStorage.setItem("PTCNotes", JSON.stringify(payload));
        } catch (error) {
            showSnackbar(`Failed to save notes`, "error");
        }
    };

    const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };



    return (
        <Grid container spacing={2} style={{ padding: '20px' }}>
            <KenSnackbar
                open={snackbarOpen}
                message={snackbarMessage}
                severity={snackbarSeverity}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // Change to top position
            />
            <Grid item xs={12} md={9}>
                <MyStudentProfile />
            </Grid>
            <Grid item xs={12} md={3}>
                <Paper
                    elevation={0}
                    sx={{
                        width: "100%",
                        height: '100%',
                        borderRadius: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden'
                    }}
                >
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        sx={{ px: 2 }}
                        textColor="primary"
                        indicatorColor="primary"
                    >
                        <Tab label="Pre - meeting" sx={{ textTransform: 'none', fontWeight: 600 }} />
                        <Tab label="Post - meeting" sx={{ textTransform: 'none', fontWeight: 400 }} />
                    </Tabs>

                    <Box sx={{ flex: 1, p: 2 }}>
                        {tabValue === 0 ? (
                            <ReactQuill
                                theme="snow"
                                value={preMeetingNote}
                                onChange={setPreMeetingNote}
                                modules={modules}
                                formats={formats}
                                placeholder="Write pre-meeting notes..."
                                style={{ height: '60vh', border: 'none' }}
                            />
                        ) : (
                            <ReactQuill
                                theme="snow"
                                value={postMeetingNote}
                                onChange={setPostMeetingNote}
                                modules={modules}
                                formats={formats}
                                placeholder="Write post-meeting notes..."
                                style={{ height: '60vh', border: 'none' }}
                            />
                        )}
                    </Box>

                    <Box sx={{ p: 2 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={handlePostPreMeeting}
                            sx={{ fontSize: '12px' }}
                        >
                            Save Notes
                        </Button>
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default ParentSpecific;
